var _style, _circle, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedemptionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000140714889018349587390000013154482408524815282_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 184.3 167.6",
    style: {
      enableBackground: "new 0 0 184.3 167.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;fill:#F9D1CF;enable-background:new    ;}\r\n\t.st1{clip-path:url(#SVGID_00000070094161919705302820000010470492096054786450_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{opacity:0.5;fill:#FFD500;enable-background:new    ;}\r\n\t.st4{fill:#E3E6ED;}\r\n\t.st5{fill:#7AD49E;}\r\n\t.st6{fill:#FFB000;}\r\n\t.st7{fill:#8ADBEF;}\r\n\t.st8{opacity:0.15;fill:#7AD49E;enable-background:new    ;}\r\n\t.st9{opacity:0.15;fill:#FFB000;enable-background:new    ;}\r\n\t.st10{opacity:0.15;fill:#8ADBEF;enable-background:new    ;}\r\n\t.st11{fill:#F9D1CF;}\r\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st13{fill:#17204A;}\r\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 109.8,
    cy: 65.8,
    r: 65.8
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M15,33.2h116.6c7.4,0,13.5,6,13.5,13.5v101.2c0,7.4-6,13.5-13.5,13.5H15c-7.4,0-13.5-6-13.5-13.5V46.7 C1.5,39.3,7.5,33.2,15,33.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#F9D1CF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136407596502739544750000008824324841624981664_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000136407596502739544750000008824324841624981664_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,54.6c0-1.3,1.1-2.4,2.4-2.4h18.1c0.9,0,1.7-0.5,2.1-1.3l3.9-7.3c0.4-0.8,1.2-1.3,2.1-1.3h40 c0.9,0,1.7,0.5,2.1,1.3l3.8,7.3c0.4,0.8,1.2,1.3,2.1,1.3h102v115.4H2.4c-1.3,0-2.4-1.1-2.4-2.4V54.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#FFD500",
      strokeWidth: 1.77
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.9,45.9L31.9,45.9c1.3,0,2.4,1.1,2.4,2.4l0,0c0,1.3-1.1,2.4-2.4,2.4l0,0c-1.3,0-2.4-1.1-2.4-2.4l0,0 C29.5,47,30.6,45.9,31.9,45.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39,47.1h17.7c0.7,0,1.2,0.5,1.2,1.2l0,0c0,0.7-0.5,1.2-1.2,1.2H39c-0.7,0-1.2-0.5-1.2-1.2l0,0 C37.8,47.6,38.3,47.1,39,47.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.5,78.8H44c1.2,0,2.2,1,2.2,2.2v27c0,1.2-1,2.2-2.2,2.2H12.5c-1.2,0-2.2-1-2.2-2.2V81 C10.2,79.8,11.2,78.8,12.5,78.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53,74.2h38.3c1.2,0,2.2,1,2.2,2.2v32.6c0,1.2-1,2.2-2.2,2.2H53c-1.2,0-2.2-1-2.2-2.2V76.5 C50.7,75.3,51.7,74.2,53,74.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.2,78.8h31.5c1.2,0,2.2,1,2.2,2.2v27c0,1.2-1,2.2-2.2,2.2h-31.5c-1.2,0-2.2-1-2.2-2.2V81 C98,79.8,99,78.8,100.2,78.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M12.5,115.9h34.9c1.2,0,2.2,1,2.2,2.2v29.3c0,1.2-1,2.2-2.2,2.2H12.5c-1.2,0-2.2-1-2.2-2.2v-29.3 C10.2,116.9,11.2,115.9,12.5,115.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M55.2,115.9H89c1.2,0,2.2,1,2.2,2.2v29.3c0,1.2-1,2.2-2.2,2.2H55.2c-1.2,0-2.2-1-2.2-2.2v-29.3 C53,116.9,54,115.9,55.2,115.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M96.9,115.9h34.9c1.2,0,2.2,1,2.2,2.2v29.3c0,1.2-1,2.2-2.2,2.2H96.9c-1.2,0-2.2-1-2.2-2.2v-29.3 C94.6,116.9,95.6,115.9,96.9,115.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M14.2,60.8L14.2,60.8c2.2,0,3.9,1.8,3.9,3.9l0,0c0,2.2-1.8,3.9-3.9,3.9l0,0c-2.2,0-3.9-1.8-3.9-3.9l0,0 C10.2,62.5,12,60.8,14.2,60.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.6,61.9h6.8c1.2,0,2.2,1,2.2,2.3l0,0c0,1.2-1,2.2-2.2,2.2h-6.8c-1.2,0-2.2-1-2.2-2.2l0,0 C20.4,62.9,21.4,61.9,22.6,61.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M71.4,96.9l5.1,38.8l7.5-11.4l7.5,13l7-4l-7.5-13l12.9-1.6C103.8,118.7,71.4,96.9,71.4,96.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M76.5,135.7l-0.8,0.1c0.1,0.4,0.3,0.6,0.7,0.7c0.3,0.1,0.7-0.1,0.9-0.4C77.2,136.2,76.5,135.7,76.5,135.7z  M71.4,96.9l0.5-0.7c-0.3-0.2-0.6-0.2-0.9,0c-0.3,0.2-0.4,0.5-0.4,0.8C70.5,97,71.4,96.9,71.4,96.9z M84,124.3l0.7-0.4 c-0.2-0.2-0.4-0.4-0.7-0.4c-0.3,0-0.6,0.1-0.7,0.4L84,124.3L84,124.3z M91.5,137.3l-0.7,0.4c0.2,0.4,0.8,0.5,1.2,0.3L91.5,137.3z  M98.4,133.3l0.4,0.7c0.4-0.2,0.5-0.8,0.3-1.1C99.2,132.9,98.4,133.3,98.4,133.3z M90.9,120.3l-0.1-0.8c-0.3,0-0.5,0.2-0.7,0.5 c-0.1,0.2-0.1,0.6,0,0.8C90.2,120.7,90.9,120.3,90.9,120.3z M103.8,118.7l0.1,0.8c0.3,0,0.6-0.3,0.7-0.6s-0.1-0.7-0.3-0.9 L103.8,118.7L103.8,118.7z M77.3,135.6l-5.1-38.8L70.6,97l5.1,38.8C75.6,135.8,77.3,135.6,77.3,135.6z M83.3,123.9l-7.5,11.4 l1.4,0.9l7.5-11.4L83.3,123.9L83.3,123.9z M92.2,136.9l-7.5-13l-1.5,0.8l7.5,13L92.2,136.9L92.2,136.9z M98,132.5l-7,4l0.8,1.5l7-4 L98,132.5z M90.2,120.7l7.5,13l1.5-0.8l-7.5-13C91.7,119.9,90.2,120.7,90.2,120.7z M103.7,117.8l-12.9,1.6l0.2,1.7l12.9-1.6 L103.7,117.8z M70.9,97.6l32.4,21.8l0.9-1.4L71.9,96.2L70.9,97.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionIcon);
export default __webpack_public_path__ + "static/media/Redemption-icon.b98e77b555b3a9be13d77632b9d2ea49.svg";
export { ForwardRef as ReactComponent };